import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import classnames from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import MobileThumbContent from '../_partials/MobileThumbContent';
import TopInfoBar from '../_partials/TopInfoBar';
import BottomInfoBar from '../_partials/BottomInfoBar';
import s from './Default.scss';
const TOP_EXTRA_HEIGHT = parseInt(s['topExtrasHeight'], 10);
const BOTTOM_EXTRA_HEIGHT = parseInt(s['bottomExtrasHeight'], 10);
const MINIMUM_DUMBO_HEIGHT_FOR_EXTRAS = 50; // this one is pulled from behind
export const EXTRAS_HEIGHT = TOP_EXTRA_HEIGHT + BOTTOM_EXTRA_HEIGHT;
const DefaultMobileThumb = ({ className, deviation, height, responsive, style, width, extraActions })=>{
    const hasEnoughHeightForExtras = !!height && height > EXTRAS_HEIGHT + MINIMUM_DUMBO_HEIGHT_FOR_EXTRAS;
    return /*#__PURE__*/ React.createElement(Section, {
        className: classnames(s['root'], hasEnoughHeightForExtras && s['with-extras'], className),
        style: _object_spread({
            width,
            height
        }, style)
    }, /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "DefaultMobileThumb"
    }, hasEnoughHeightForExtras ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(TopInfoBar, {
        deviation: deviation,
        extraActions: extraActions,
        className: s['top-extras']
    }), /*#__PURE__*/ React.createElement(MobileThumbContent, {
        deviation: deviation,
        width: width,
        height: height - EXTRAS_HEIGHT,
        responsive: responsive
    }), /*#__PURE__*/ React.createElement(BottomInfoBar, {
        deviation: deviation,
        className: s['bottom-extras']
    })) : /*#__PURE__*/ React.createElement(MobileThumbContent, {
        deviation: deviation,
        width: width,
        height: height,
        responsive: responsive
    })));
};
DefaultMobileThumb.displayName = 'DefaultMobileThumb';
export default DefaultMobileThumb;
